// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2Zp8e","rootSmall":"AddTileButton_rootSmall__3_1x-"};